import { useQuery } from "@tanstack/react-query";
import type { GetUserApiResponse } from "./types/GetUser";
import useUserService from "./useUserService";

const GET_USER_KEY = "get-user-data" as const;

const VEHICLE_LIMIT_BY_ACCOUNT_TYPE = {
	PERSON: 5,
	BUSINESS: 10,
} as const;

const GetUserApiAdapter = (data: GetUserApiResponse) => {
	const [firstCustomer] = data.completeUser.customer;
	const payload = {
		...data.completeUser.account,
		...firstCustomer,
	};
	return {
		...payload,
		...(payload.alternatePhone && {
			alternatePhoneNumber: `${payload.alternatePhone.areaCode}${payload.alternatePhone.phoneNo}`,
		}),
		...(payload.postalAddresses.length > 0 &&
			(() => {
				const [firstAddress] = payload.postalAddresses;
				return {
					address1: firstAddress.addressLine1,
					address2: firstAddress.addressLine2,
					city: firstAddress.city,
					state: firstAddress.state,
					zip: firstAddress.postalCode.substring(0, 5),
				};
			})()),
		phoneNumber: payload.telephoneNumber,
		maxVehicles: VEHICLE_LIMIT_BY_ACCOUNT_TYPE[payload.customerType] as
			| number
			| undefined,
	};
};

// By default we'll always make this call, but you can pass in a check that if false will skip the api call
const useUserQuery = (forceRefresh = true) => {
	const service = useUserService();
	return useQuery({
		queryKey: [GET_USER_KEY, forceRefresh],
		queryFn: async () => {
			const { data } = await service.get.user();
			return GetUserApiAdapter(data);
		},
		enabled: forceRefresh,
	});
};

export default useUserQuery;
